import axios from 'axios';
import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";
import {getAuth} from "firebase/auth";
import {signedUserData} from "../../utils/user";

const log = require("loglevel").getLogger("userReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	user: null,
	users: [],
	menuOpen: localStorage.getItem(constants.SIDEBAR_STATE_STORAGE_KEY) === '1',
	awsAccounts: [],
	awsAccountsTotal: 0,
	msAccounts: [],
	msAccountsTotal: 0
});

function userReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset user state");
			return initialState;
		}
		case actionTypes.USER_SIGNED_IN: {
			const user = action.data;
			if (!user.customers) {
				user.customers = [];
			}

			// if (process.env.NODE_ENV === 'development') {
				localStorage.setItem(constants.STORAGE_SIGNED_USER_KEY, JSON.stringify(user));
			// }
			axios.defaults.headers.common['Connact-Access'] = user.uid;

			return {
				...state,
				user
			};
		}
		case actionTypes.TOGGLE_MENU: {
			const menuMode = !state.menuOpen;
			localStorage.setItem(constants.SIDEBAR_STATE_STORAGE_KEY, menuMode ? '1' : '0');

			return {
				...state,
				menuOpen: menuMode
			};
		}
		case actionTypes.USERS_LOADED: {
			return {
				...state,
				users: action.data
			}
		}
		case actionTypes.ACCOUNTS_LOADED: {
			if(action.vendor === 'aws') {
				return {
					...state,
					awsAccounts: action.data,
					awsAccountsTotal: action.total
				};
			}
			else {
				return {
					...state,
					msAccounts: action.data,
					msAccountsTotal: action.total
				};
			}
		}
		case actionTypes.TOGGLE_USER_ENABLED: {
			const {users} = state;
			const index = users.findIndex(u => u.email === action.data);

			if(index > -1) {
				users[index].is_enabled = !users[index].is_enabled;
			}

			return {
				...state,
				users
			}
		}
		case actionTypes.UPDATE_USER_TOKEN: {
			// if (process.env.NODE_ENV === 'development') {
				let signedInUser = signedUserData();
				if(signedInUser) {
					signedInUser = JSON.parse(signedInUser);
				}

				if (!signedInUser.customers) {
					signedInUser.customers = [];
				}

				signedInUser.uid = action.data;
				localStorage.setItem(constants.STORAGE_SIGNED_USER_KEY, JSON.stringify(signedInUser));
			// }

			const { user } = state;
			user.uid = action.data;
			axios.defaults.headers.common['Connact-Access'] = user.uid;

			return {
				...state,
				user
			};
		}
		case actionTypes.USER_SIGNED_OUT: {
			localStorage.removeItem(constants.STORAGE_SIGNED_USER_KEY);
			getAuth().signOut().then(() => {
				console.log("firebase signed out");
			});

			axios.defaults.headers.common['Connact-Access'] = null;

			return {
				...state,
				user: null,
			};
		}
		default:
			return state;
	}
}

export default userReducer;
